import React from 'react';
export const IntroSection = () => {
  return <section className="py-6 md:py-8 bg-bttf-bg border-t border-b border-bttf-subtext/20" id="book" data-id="element-205">
      <div className="container mx-auto px-4" data-id="element-206">
        <div className="text-center mb-6" data-id="element-207">
          <h2 className="text-3xl md:text-4xl font-bold font-future tracking-wide bg-gradient-main text-transparent bg-clip-text mb-2" data-id="element-208">
            Now Available - Limited Release
          </h2>
          <div className="w-20 h-1 bg-bttf-primary mx-auto" data-id="element-209"></div>
        </div>
        <div className="max-w-3xl mx-auto" data-id="element-210">
          <p className="text-xl text-center mb-3 text-bttf-text" data-id="element-211">
            Some films entertain.{' '}
            <span className="font-semibold text-bttf-accent" data-id="element-212">
              A few inspire.
            </span>{' '}
            But once in a lifetime, a story changes how we see time itself.
          </p>
          <p className="text-lg mb-3 text-bttf-subtext" data-id="element-213">
            In 1985, Back to the Future ignited imaginations around the world.
            It wasn't just about time travel—it was about courage, destiny, and
            the magic of friendship between a wild inventor and a kid who just
            wanted to get home.
          </p>
          <p className="text-lg text-bttf-subtext" data-id="element-214">
            Four decades later, the story still hums like a DeLorean engine
            under starlight. And now, that legacy is captured forever in Back to
            the Future: 40th Anniversary Collector's Edition — a cinematic
            keepsake for dreamers of every generation.
          </p>
        </div>
      </div>
    </section>;
};